import {Modal} from "react-bootstrap";
import React from "react";
import {observable} from "@legendapp/state";
import {observer} from "@legendapp/state/react";
import {Button, SaveButton} from "_ui/Button";
import {Sound, SoundService} from "_services/sound.service";
import {toastInfo} from "_components/ToastProvider";

const $link = observable<string>('');
const $isRendered = observable(false);
export const $open = observable(false);
export const open = (link: string) => {
    if (!$isRendered.peek()) {
        return;
    }

    $link.set(link);
    toastInfo("Audiência iniciada! Iniciando a video chamada");
    SoundService.loopPlay(Sound.HearingStarted);
    $open.set(true);
}

export const close = () => {
    $open.set(false);
    SoundService.stop(Sound.HearingStarted);
}

export const HearingStarted =
    observer(() => {

        const ok = () => {
            window.open($link.peek(), "__blank");
            close();
        }

        $isRendered.set(true);
        return (
            <Modal show={$open.get()} centered>
                <Modal.Header>
                    <h4 className="modal-title">Audiência começou</h4>
                </Modal.Header>
                <Modal.Body>
                    <p>Clique em ok para entrar na chamada de video.</p>

                </Modal.Body>
                <Modal.Footer>
                    {/*<CloseButton onClick={close}/>*/}
                    <Button icon='fa-thumbs-up' text='Ok' onClick={ok}/>
                </Modal.Footer>
            </Modal>
        )
    })
;
